import React from 'react';

import { Box, Button, Typography } from '@mui/material';
import StatusIconCDS from 'app/shared/componentsRestyled/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { NEXT_ACTION_SEVERITY } from '../PathToSubmission.constants';
import { PathToSubmissionTestIds } from '../PathToSubmission.testIds';

import { SEVERITY_ICON } from './NextActionCallout.constants';
import {
  actionsRowStyles,
  getCalloutStyles,
  getTitleStyles,
  iconColumnStyles,
  textColumnStyles,
} from './NextActionCallout.styles';

const NextActionCallout = ({ severity, title, description, primaryCta, secondaryCta }) => (
  <Box sx={getCalloutStyles(severity)}>
    <Box sx={iconColumnStyles}>
      <StatusIconCDS size={32} type={SEVERITY_ICON[severity]} />
    </Box>
    <Box sx={textColumnStyles}>
      <Typography sx={getTitleStyles(severity)} variant="bold14">
        {title}
      </Typography>
      <Typography color="text.secondary" variant="regular12">
        {description}
      </Typography>
    </Box>
    <Box sx={actionsRowStyles}>
      {secondaryCta && (
        <Button
          data-testid={PathToSubmissionTestIds.NEXT_ACTION_SECONDARY_BUTTON}
          size="small"
          variant="outlined"
          onClick={secondaryCta.onClick}
        >
          {secondaryCta.label}
        </Button>
      )}
      {primaryCta && (
        <Button
          data-testid={PathToSubmissionTestIds.NEXT_ACTION_PRIMARY_BUTTON}
          disabled={primaryCta.isDisabled}
          size="small"
          variant="contained"
          onClick={primaryCta.onClick}
        >
          {primaryCta.label}
        </Button>
      )}
    </Box>
  </Box>
);

NextActionCallout.propTypes = {
  severity: PropTypes.oneOf(Object.values(NEXT_ACTION_SEVERITY)).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  primaryCta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
  }),
  secondaryCta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
};

export default NextActionCallout;
